<template>
  <div class="big">
    <div class="section">
      <div class="sectioncontent">
        <div class="searchbox">
          <i class="el-icon-search" @click="tosearch"></i>
          <input
            type="text"
            name=""
            id=""
            v-model="input"
            placeholder="请输入课程名称"
          />
        </div>
        <div class="classify">
          <ul class="search">
            <li>
              <div class="searchtitle">
                <span>|</span>
                <span>专业大类：</span>
              </div>
              <ol class="searchcontent">
                <li
                  :class="{ chosedli: choseid === '' }"
                  @click="chosesubjectList('')"
                >
                  全部 <span></span>
                </li>
                <li
                  v-for="(item, index) in subjectList"
                  :key="item.ID"
                  :listid="item.ID"
                  :class="{ chosedli: choseid === index }"
                  @click="chosesubjectList(index, item.ID)"
                >
                  {{ item.Name }}
                  <span>({{ item.Numbers }})</span>
                </li>
              </ol>
            </li>
            <li>
              <div class="searchtitle">
                <span>|</span>
                <span>课程年份：</span>
              </div>
              <ol class="searchcontent">
                <li
                  :class="{ chosedyearli: choseyearid === '' }"
                  @click="choseyearList('')"
                >
                  全部
                </li>
                <li
                  v-for="(item, index) in yearlist"
                  :key="item.ID"
                  :class="{ chosedyearli: choseyearid === index }"
                  @click="choseyearList(index, item.Year)"
                >
                  {{ item.Year }}
                </li>
              </ol>
            </li>
            <li>
              <div class="searchtitle threecourse">
                <span>|</span>
                <span>课程搜索：</span>
              </div>
              <ol class="searchcontent">
                <div class="choseacademy">
                  <span>学院</span>
                  <el-select v-model="value" placeholder="请选择学院">
                    <el-option label="请选择" value=""> </el-option>
                    <el-option
                      v-for="item in options"
                      :key="item.Id"
                      :label="item.XueYuanName"
                      :value="item.Id"
                    >
                      {{ item.XueYuanName }}
                    </el-option>
                  </el-select>
                </div>
                <div class="searchtext">
                  <span>课程名称</span>
                  <el-input v-model="input" placeholder="请输入"></el-input>
                </div>
                <button class="tosearch" @click="tosearch">立即搜索</button>
              </ol>
            </li>
          </ul>
          <div class="experiment">
            <div class="extext">
              <img src="../../public/pc/01-icon-实验资源.png" alt="" />
              <span>实验资源</span>
            </div>
            <div class="experimentcontent">
              <div
                @click="toexperiment(item.Id)"
                v-for="item in experimentlist"
                :key="item.Id"
              >
                <img :src="item.Cover" alt="" />
                <h2>{{ item.CourseName }}</h2>
                <div class="experimenttext">
                  <span>{{ item.DisciplineCategoryName }}</span>
                  <div class="browse">
                    <div class="browseone">
                      <div class="img1"></div>
                      <!-- <img src="../../public/pc/01-icon-浏览量.png" alt=""> -->
                      <span>{{ item.VistRecordNumbers }}</span>
                    </div>
                    <div class="browseone">
                      <div class="img2"></div>
                      <!-- <img src="../../public/pc/01-icon-实验人数.png" alt=""> -->
                      <span>{{ item.CollectNumbers }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="button">
                <button
                  class="more"
                  @click="seemore"
                  v-if="TotalNumbers > 8 && TotalNumbers > TotalNumbersqingqiu"
                >
                  查看更多
                </button>
                <button
                  class="more"
                  @click="shouhui"
                  v-if="TotalNumbers <= TotalNumbersqingqiu"
                >
                  点击收回
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="bodytwo">
          <div class="news">
            <div class="newstitle">
              <div class="newstitleleft">
                <img src="../../public/pc/01-icon-新闻资讯.png" alt="" />
                <span>新闻资讯</span>
              </div>
              <img
                src="../../public/pc/01-icon-more.png"
                alt=""
                @click="tonoewslist"
              />
            </div>
            <ul class="newscontent">
              <li
                v-for="item in newsList"
                :key="item.ContentId"
                :newsid="item.ContentId"
                @click="tonews(item.ContentId)"
              >
                <div class="newscontenttext">
                  <h2>{{ item.Subtitle }}</h2>
                  <span v-html="item.Content"> </span>
                  <div class="posttime">
                    {{ item.ReleaseDate.slice(0, 10) }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="ranking">
            <div class="newstitle">
              <div class="newstitleleft">
                <img src="../../public/pc/01-icon-实验资源排行.png" alt="" />
                <span>实验资源排行</span>
              </div>
              <img
                src="../../public/pc/01-icon-more.png"
                alt=""
                @click="toDetails"
              />
            </div>
            <ul class="rankingcontent">
              <li
                v-for="(item, index) in courseList"
                :key="item.Id"
                :crouseId="item.id"
                @click="toexperiment(item.Id)"
              >
                <div class="num">
                  <span>{{ Number(index) + 1 }}</span>
                </div>
                <span>
                  {{ item.CourseName }}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="bodythree">
          <div class="newstitle">
            <div class="newstitleleft">
              <img src="../../public/pc/01-icon-最新资源.png" alt="" />
              <span>最新资源推荐</span>
            </div>
            <img
              src="../../public/pc/01-icon-more.png"
              alt=""
              @click="toDetails"
            />
          </div>
          <ul class="recommend">
            <li
              v-for="item in newexperimentlist"
              :key="item.Id"
              @click="toexperiment(item.Id)"
            >
              <div class="img">
                <img :src="item.Cover" alt="" class="fengmian" />
                <img
                  src="../../public/pc/01-icon-new.png"
                  alt=""
                  class="icon"
                  v-if="item.Cover != ''"
                />
              </div>
              <h2>{{ item.CourseName }}</h2>
              <div class="recommendtext">
                <span>{{ item.DisciplineCategoryName }}</span>
                <div class="browse">
                  <div class="browseone">
                    <img src="../../public/pc/01-icon-浏览量.png" alt="" />
                    <span>{{ item.VistRecordNumbers }}</span>
                  </div>
                  <div class="browseone">
                    <!-- <div class="img1"></div> -->
                    <img src="../../public/pc/01-icon-实验人数.png" alt="" />
                    <span>{{ item.CollectNumbers }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="bodyfour">
          <div class="visit">
            <div class="newstitle">
              <div class="newstitleleft">
                <img src="../../public/pc/01-icon-访问量统计.png" alt="" />
                <span>访问量统计</span>
              </div>
            </div>
            <div id="visitstatistics" ref="visitstatistics"></div>
          </div>
          <div class="visit">
            <div class="newstitle">
              <div class="newstitleleft">
                <img src="../../public/pc/01-icon-访问量统计.png" alt="" />
                <span>学习时长统计</span>
              </div>
            </div>
            <div id="studystatistics" ref="studystatistics"></div>
          </div>
        </div>
      </div>
      <div class="bodyfive">
        <div class="fivecontent">
          <div class="fivecontent_head">
            <span
              ><img
                src="../../public/pc/01-icon-友情链接.png"
                alt=""
              />友情链接</span
            >
          </div>
          <ul>
            <li @click="towaibu('http://www.moe.gov.cn/')">
              <img src="../../public/pc/01-友链1.png" alt="" />
              <span>中华人民共和国教育部</span>
            </li>
            <li @click="towaibu('http://jyt.jiangsu.gov.cn/')">
              <img src="../../public/pc/01-友链2.png" alt="" />
              <span>江苏省教育厅</span>
            </li>
            <li @click="towaibu('https://www.jse.edu.cn/')">
              <img src="../../public/pc/01-友链3.png" alt="" />
              <span>江苏省智慧教育云平台</span>
            </li>
            <li @click="towaibu('http://www.njau.edu.cn/')">
              <img src="../../public/pc/01-友链4.png" alt="" />
              <span>南京农业大学</span>
            </li>
            <li @click="towaibu('https://www.ilab-x.com/')">
              <img src="../../public/pc/01-友链5.png" alt="" />
              <span>实验空间</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

import {
  subjectList,
  experimentlist,
  CreateYearList,
  newsList,
  LearningTimeStatistics,
  newexperimentlist,
  GetCourseSortList,
  XueYuanList,
  loginfree,
  VistRecord,
} from "@/api/index";
export default {
  name: "example",
  data() {
    return {
      visitdataY: [],
      visitdata: [],
      miandengluUserToken: "",
      token: {
        UserToken: "",
      },
      TotalNumbersqingqiu: 1,
      TotalNumbers: 1,
      choseyearid: "",
      choseid: "",
      options: [],
      value: "",
      input: "",
      experimentlistdata: {
        DisciplineCategoryId: "",
        XueYuanId: "",
        SubjectId: "",
        CreateYear: "",
        CourseName: "",
        CurrentPageIndex: 1,
        PageSize: 8,
      },
      newlistdata: {
        CurrentPageIndexP: 1,
        PageSize: 3,
      },
      newexperimentlistdata: {
        CurrentPageIndex: 1,
        PageSize: 3,
      },
      courseList: {},

      getcoursedata: {
        CurrentPageIndex: 1,
        PageSize: 10,
      },
      subjectList: {},
      yearlist: {},
      experimentlist: {},
      newsList: {},
      newexperimentlist: {},
      echartsoption: {
        title: {
          text: "",
        },
        tooltip: {},
        xAxis: {
          data: [],
          axisLabel: {
            rotate: 45,
            interval: 0,
            formatter: (dadaue) => {
              return value.split("").join("\n");
            },
          },
        },
        yAxis: {},

        series: [
          {
            axisLabel: {
              show: true,
              interval: 0,

              formatter: function (
                value //竖排显示
              ) {
                return value.split("").join("\n");
              },
            },
            data: this.visitdata,
            type: "bar",
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#66CDAA", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#F0FFF0", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            label: {
              normal: {
                // rotate:90,
                formatter: "{c}",
                color: "#333",
                show: true,
                interval: 0,
                position: "top",
                align: "center",
                textStyle: {
                  rotate: 90,
                },
              },
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.toVistRecord();
    this.toLearningTimeStatistics();
  },
  methods: {
    // 免登录
    tologinfree(data) {
      console.log(this.miandengluUserToken);
      if (this.miandengluUserToken === null) {
        loginfree(data).then((res) => {
          if (res.code === 0) {
            sessionStorage.setItem("UserAccount", res.UserInfo.UserAccount);
            sessionStorage.setItem("UserType", res.UserInfo.UserType);
            sessionStorage.setItem("UserToken", res.UserInfo.UserToken);
            setTimeout(() => {
              location.reload();
            }, 100);
          } else {
            console.log(res);
          }
        });
      }
    },
    // 外部链接
    towaibu(url) {
      window.open(url, "_blank");
    },
    // 点击跳转新闻列表
    tonoewslist() {
      this.$router.push("Newslist");
    },
    // 点击跳转新闻页面
    tonews(id) {
      this.$router.push({
        path: "news",
        query: {
          id: id,
        },
      });
    },
    // 点击收回
    shouhui() {
      this.experimentlistdata.PageSize -= 8;
      this.TotalNumbersqingqiu = this.experimentlistdata.PageSize;
      this.getexperimentlist(this.experimentlistdata);
    },
    // 点击查看更多
    seemore() {
      this.experimentlistdata.PageSize += 8;
      this.TotalNumbersqingqiu = this.experimentlistdata.PageSize;
      this.getexperimentlist(this.experimentlistdata);
    },
    // 点击筛选课程
    chosesubjectList(index, id) {
      this.choseid = index;
      this.experimentlistdata.DisciplineCategoryId = id;
      // console.log(this.experimentlistdata.DisciplineCategoryId);
      this.getexperimentlist(this.experimentlistdata);
    },
    // 点击筛选年份
    choseyearList(id, Year) {
      this.choseyearid = id;
      this.experimentlistdata.CreateYear = Year;
      this.getexperimentlist(this.experimentlistdata);
    },
    // 选择搜索
    tosearch() {
      this.experimentlistdata.CourseName = this.input;
      this.experimentlistdata.XueYuanId = this.value;

      // console.log();
      this.getexperimentlist(this.experimentlistdata);
    },
    // 获取学科列表
    getstudy() {
      subjectList().then((res) => {
        if (res.code === 0) {
          this.subjectList = res.DisciplineCategoryList;
        }
      });
    },
    // 获取实验资源
    getexperimentlist(data) {
      experimentlist(data).then((res) => {
        if (res.code === 0) {
          this.TotalNumbers = res.TotalNumbers;
          this.experimentlist = res.CourseList;
          // console.log(res, '实验资源');
        }
      });
    },
    // 获取资源年份
    getCreateYearList() {
      CreateYearList().then((res) => {
        if (res.code === 0) {
          this.yearlist = res.CreateYearList;
        }
      });
    },
    // 获取新闻资讯
    getnewsList(data) {
      newsList(data).then((res) => {
        if (res.code === 0) {
          this.newsList = res.NewsList;
        }
      });
    },
    // 获取最新课程
    getnewexperiment(data) {
      newexperimentlist(data).then((res) => {
        if (res.code === 0) {
          this.newexperimentlist = res.CourseList;
        }
      });
    },
    // 获取资源排行
    getcourse(data) {
      GetCourseSortList(data).then((res) => {
        if (res.code === 0) {
          this.courseList = res.CourseList;
          // console.log(this.courseList);
        }
      });
    },
    toexperiment(id) {
      this.$router.push({
        path: "experiment",
        query: {
          id: id,
        },
      });
    },
    // 获取学院信息
    getxueyuanList(data) {
      XueYuanList(data).then((res) => {
        if (res.code === 0) {
          this.options = res.XueYuanList;
        }
        // console.log(this.options, '学院信息');
      });
    },
    // 跳转到实验资源排行
    toDetails() {
      this.$router.push("/Details");
    },
    // echarts
    getecharts(dom, data) {
      const myChart = echarts.init(dom);
      myChart.setOption(data);
    },
    // 首页获取访问量统计
    toVistRecord() {
      VistRecord({
        CurrentPageIndex: 1,
        PageSize: 10,
      }).then((res) => {
        if (res.code === 0) {
          // console.log(res.VistRecordList, '访问量');
          let eCharts1 = JSON.parse(JSON.stringify(this.echartsoption));
          eCharts1.xAxis.data = res.VistRecordList.map(
            (item) => item.Abbreviation
          );

          eCharts1.series[0].data = res.VistRecordList.map(
            (item) => item.VistRecordNumbers
          );

          this.visitdata = res.VistRecordList;
          console.log(this.visitdata, "访问量");
          this.getecharts(this.$refs.visitstatistics, eCharts1);
        }
      });
    },
    // 首页学习时长统计
    toLearningTimeStatistics() {
      LearningTimeStatistics({
        CurrentPageIndex: 1,
        PageSize: 10,
      }).then((res) => {
        if (res.code === 0) {
          // console.log(res, '学习时长统计');
          let eCharts2 = JSON.parse(JSON.stringify(this.echartsoption));
          eCharts2.xAxis.data = res.LearningTimeStatisticsList.map(
            (item) => item.Abbreviation
          );
          eCharts2.series[0].data = res.LearningTimeStatisticsList.map(
            (item) => item.StudyTime
          );
          this.getecharts(this.$refs.studystatistics, eCharts2);
        }
      });
    },
  },

  created() {
    this.miandengluUserToken = sessionStorage.getItem("UserToken");
    this.token.UserToken = this.$route.query.UserToken;
    // console.log(this.token);
    this.tologinfree(this.token);
    this.getstudy();
    this.getexperimentlist(this.experimentlistdata);
    this.getCreateYearList();
    this.getnewsList(this.newlistdata);
    this.getnewexperiment(this.newexperimentlistdata);
    this.getcourse(this.getcoursedata);
    this.getxueyuanList({});
  },
};
</script>

<style lang="less" >
/* 头部样式 */
.big {
  width: 100%;
  height: auto;
}

/* 内容样式 */
.section {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.sectioncontent {
  @media only screen and (max-width: 767px) {
    width: 90%;
  }

  @media only screen and (min-width: 768px) {
    width: 1200px;
  }

  margin: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.classify {
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  border: 1px solid transparent;

  @media only screen and (max-width: 767px) {
    padding: 10px 10px 32px;
  }

  @media only screen and (min-width: 768px) {
    padding: 20px 20px 32px;
  }
}

.classify > .search {
  display: flex;
  flex-direction: column;
}

.search > li {
  display: flex;
  width: auto;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 0 0;
  }

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    padding: 20px 0;
    border-bottom: 1px solid rgb(228, 227, 227);
  }
}

.classify > .search .searchtitle {
  @media only screen and (max-width: 767px) {
    font-size: 15px;
  }

  @media only screen and (min-width: 768px) {
    font-size: 20px;
  }

  color: #35374c;
  font-family: "微软雅黑";
  display: flex;
  justify-content: center;
  align-items: center;
}

.searchtitle > span {
  white-space: nowrap;
}

.searchtitle > span:nth-child(1) {
  font-weight: 800;
  font-size: 16px;
  color: #068358;
  margin-right: 10px;

  @media only screen and (max-width: 767px) {
    display: none;
  }

  @media only screen and (min-width: 768px) {
    display: block;
  }
}

.searchcontent {
  display: flex;

  @media only screen and (max-width: 767px) {
    width: 100%;
    overflow-x: scroll;
    align-items: center;
    margin-top: 10px;
    padding-bottom: 10px;
  }

  @media only screen and (min-width: 768px) {
    flex-wrap: wrap;
    align-items: center;
  }

  li {
    white-space: nowrap;
    color: #068358;
    padding: 5px 0;

    @media only screen and (max-width: 767px) {
      background-color: #f5f7fd;
    }

    @media only screen and (min-width: 768px) {
      display: flex;
      align-items: center;
    }

    span {
      @media only screen and (max-width: 767px) {
        display: none;
      }

      @media only screen and (min-width: 768px) {
      }
    }
  }
}

.searchcontent::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.choseacademy {
  padding: 0 17px;
  box-sizing: border-box;
}

.searchcontent > li {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  margin: 0px 5px;
  color: #686a7e;
  box-sizing: border-box;
  border: 1px solid transparent;

  cursor: pointer;

  @media only screen and (max-width: 767px) {
    border-radius: 20px;
  }

  @media only screen and (min-width: 768px) {
    border-radius: 15px;
  }
}

.searchcontent > li:hover {
  color: #068358;
  border: 1px solid #068358;
  background-color: #e6f2ee;
}

.searchcontent > .chosedli,
.searchcontent > .chosedyearli {
  color: #068358;

  @media only screen and (max-width: 767px) {
    color: #068358;
    border: 1px solid #068358;
    background-color: #e6f2ee;
  }

  @media only screen and (min-width: 768px) {
    color: #068358;
  }
}

.experimentcontent
  > div:hover
  > .experimenttext
  > .browse
  > .browseone
  > .img1 {
  background-image: url(../../public/pc/01-icon-浏览量-1.png);
}

.experimentcontent
  > div:hover
  > .experimenttext
  > .browse
  > .browseone
  > .img2 {
  background-image: url(../../public/pc/01-icon-实验人数-1.png);
}

.searchtext {
  display: flex;
  margin: 0 15px;
  white-space: nowrap;
  align-items: center;
}

.browseone {
  margin: 0 3px;
  display: flex;

  .img1 {
    width: 14px;
    height: 14px;
    background-image: url(../../public/pc/01-icon-浏览量.png);
    margin-right: 5px;
  }

  .img2 {
    width: 14px;
    height: 14px;
    background-image: url(../../public/pc/01-icon-实验人数.png);
    margin-right: 5px;
  }
}

.browse .browseone:last-child {
  // @media only screen and (max-width: 767px) {
  //   display: none;
  // }

  // @media only screen and (min-width: 768px) {}
}

.searchtext span,
.choseacademy span {
  margin-right: 15px;
}

.threecourse {
  box-sizing: border-box;
}

.tosearch {
  background-color: #068358;
  width: 200px;
  height: 38px;
  margin-left: 20px;
  border: none;
  outline: none;
  cursor: pointer;
  color: #fff;
  border-radius: 19px;
}

.search > li:nth-child(3) {
  border: none;
}

.experiment {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 0 0;

  @media only screen and (max-width: 767px) {
    margin-top: 10px;
  }

  @media only screen and (min-width: 768px) {
    margin-top: 30px;
  }
}

.experiment .extext {
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  border-bottom: #068358 3px solid;
  height: 100%;
  padding-bottom: 10px;

  @media only screen and (max-width: 767px) {
    width: 150px;
  }

  @media only screen and (min-width: 768px) {
    width: 180px;
  }
}

.experiment > .extext > img {
  margin: 0 10px;
}

.experimentcontent {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  @media only screen and (max-width: 767px) {
    padding-top: 0;
  }

  @media only screen and (min-width: 768px) {
    padding-top: 15px;
  }

  border-top: 1px solid rgb(228, 227, 227);
}

.search > li:nth-child(3) {
  @media only screen and (max-width: 767px) {
    display: none;
  }

  @media only screen and (min-width: 768px) {
    flex-wrap: nowrap;
    display: flex;
  }

  ol {
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;

    div {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;

      span {
        white-space: nowrap;
      }
    }
  }
}

.experimentcontent > div {
  font-size: 14px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-direction: column;
  align-items: flex-start;

  @media only screen and (max-width: 767px) {
    width: 49%;
    height: 170px;

    padding: 10px 5px;
  }

  @media only screen and (min-width: 768px) {
    width: 24%;
    height: 260px;
    padding: 18px 10px;
  }

  margin: 0 0.5% 1px;
  cursor: pointer;
  box-sizing: border-box;
}

.experimentcontent > div:hover {
  background-color: #e1f6ef;
  color: #068358;
  border-radius: 10px;
}

.experimentcontent > div:hover > .experimenttext > span {
  color: #8abbaa;
}

.experimentcontent > div:hover > .experimenttext > .browse span {
  color: #8abbaa;
}

.experimentcontent > div:hover span {
  color: #068358;
}

.experimentcontent > div > img {
  width: 100%;

  @media only screen and (max-width: 767px) {
    height: 80px;
  }

  @media only screen and (min-width: 768px) {
    height: 160px;
  }

  border-radius: 5px;
}

.experimentcontent > div > h2 {
  font-weight: 400;
  font-size: 15px;
  margin: 10px 0;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  text-align: left;
}

.experimentcontent > div .experimenttext span {
  box-sizing: border-box;
  color: #999;
}

.experimentcontent > div > .experimenttext {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.experimentcontent > div > .experimenttext > .browse {
  display: flex;
}

.experimentcontent > .button {
  width: 100%;
  display: flex;
  height: 70px;
  justify-content: center;
  align-items: center;
}

.button > .more {
  width: 150px;
  height: 40px;
  background-color: #f1fffa;
  color: #068358;
  border: #068358 solid 1px;
  border-radius: 30px;
  font-size: 15px;
  cursor: pointer;
}

.search > li:nth-child(1) .searchtitle {
  align-self: start;
}

.search > li:nth-child(1) ol li {
  @media only screen and (max-width: 767px) {
  }

  @media only screen and (min-width: 768px) {
    align-self: start;
    padding: 4px 10px;
    margin-bottom: 5px;
  }
}

.experimentcontent > div:last-child:hover {
  background-color: transparent;
}
</style>

<style lang="less" scoped>
.bodytwo {
  justify-content: space-between;
  margin-bottom: 25px;
  width: 100%;
  margin-top: 20px;

  @media only screen and (max-width: 767px) {
    display: block;
  }

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    display: flex;
    height: 544px;
  }
}

.bodytwo > .news {
  @media only screen and (max-width: 767px) {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
  }

  @media only screen and (min-width: 768px) {
    width: 64%;
    height: 100%;
  }

  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 20px;
  margin-right: 25px;
  box-sizing: border-box;
  overflow: hidden;
}

.newstitle {
  font-size: 18px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgb(228, 227, 227);
}

.bodytwo > .news > .newstitle {
  font-size: 18px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgb(228, 227, 227);
}

.newstitleleft {
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  border-bottom: #068358 3px solid;

  @media only screen and (max-width: 767px) {
    padding-right: 30px;
  }

  @media only screen and (min-width: 768px) {
    width: 180px;
  }

  height: 100%;
  padding-bottom: 10px;
  box-sizing: border-box;
}

.newstitleleft > img {
  margin: 0 10px;
}

.newstitle > img {
  width: 7px;
  height: 15px;
  cursor: pointer;
  margin-bottom: 8px;
}

.bodytwo > .ranking {
  border-radius: 10px;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  background-color: #fff;

  @media only screen and (max-width: 767px) {
    width: 100%;
  }

  @media only screen and (min-width: 768px) {
    width: 34%;
  }
}

.newscontent {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
}

.newscontent > li {
  display: flex;
  margin-top: 10px;
  padding: 15px 0;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  position: relative;
  border-bottom: 1px solid rgb(228, 227, 227);
  cursor: pointer;

  .databox {
    align-self: start;
  }
}

.newscontent li .databox {
  @media only screen and (max-width: 767px) {
    width: 75px;
    height: 65px;
  }

  @media only screen and (min-width: 768px) {
    width: 100px;
    height: 80px;
  }

  display: flex;
  flex-direction: column;
  background-image: url(../../public/pc/01-日期1.png);
  background-repeat: no-repeat;
  background-size: contain;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 15px 0 10px;
}

.databox > span:first-child {
  @media only screen and (max-width: 767px) {
    font-size: 15px;
  }

  @media only screen and (min-width: 768px) {
    font-size: 28px;
  }

  color: #068358;
}

.databox > span:last-child {
  @media only screen and (max-width: 767px) {
    font-size: 8px;
  }

  @media only screen and (min-width: 768px) {
    font-size: 14px;
  }

  color: #068358;
}

.newscontent > li > img {
  margin-right: 25px;

  @media only screen and (max-width: 767px) {
    width: 86px;
  }

  @media only screen and (min-width: 768px) {
    width: 86px;
  }
}

.newscontent > li > .newscontenttext {
  display: flex;
  width: 96%;
  flex-direction: column;
  text-align: left;
  align-self: start;

  .posttime {
    margin-left: 10px;
    margin-top: 10px;

    @media only screen and (max-width: 767px) {
    }

    @media only screen and (min-width: 768px) {
      font-size: 18px;
    }

    color: #999;

    @media only screen and (max-width: 767px) {
      display: block;
      font-size: 12px;
    }

    @media only screen and (min-width: 768px) {
      display: none;
    }
  }
}

.newscontenttext > h2 {
  width: 100%;
  box-sizing: border-box;
  padding-left: 10px;
  font-size: 16px;
  overflow: hidden;

  @media only screen and (max-width: 767px) {
    color: #333;
  }

  @media only screen and (min-width: 768px) {
    color: #068358;
  }

  margin-bottom: 5px;
}

.newscontenttext > .newstime {
  line-height: 25px;
  color: #999;
  font-size: 15px;
  margin-bottom: 2px;
  display: -webkit-box !important;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.newscontenttext > span {
  width: 100%;
  height: 75px;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  line-height: 25px;
  color: #999;
  font-size: 15px;
  box-sizing: border-box;
  padding-left: 10px;

  @media only screen and (max-width: 767px) {
    display: none;
  }

  @media only screen and (min-width: 768px) {
    display: -webkit-box !important;
  }
}

.newscontent > li > span {
  color: #068358;
}

.newscontent > li > span:nth-of-type(1) {
  font-size: 28px;
  position: absolute;
  left: 28px;
  top: 26px;
}

.newscontent > li > span:nth-of-type(2) {
  font-size: 14px;
  position: absolute;
  left: 8px;
  top: 68px;
}

.newscontent > li:nth-of-type(3) {
  border: none;
}

.newscontent > li:nth-of-type(3) > span {
  color: #999;
}

.newsmore {
  width: 100px;
  border-radius: 20px;
  color: #068358;
  margin-top: 20px;
  border: 1px solid #068358;
}

.bodytwo > .ranking > .newstitle {
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgb(228, 227, 227);
  margin-bottom: 20px;
}

.rankingcontent {
  @media only screen and (max-width: 767px) {
  }

  @media only screen and (min-width: 768px) {
  }

  display: flex;
  height: 100%;
  flex-direction: column;
  box-sizing: border-box;
}

.rankingcontent > li {
  display: flex;
  margin-bottom: 20px;
  cursor: pointer;
}

.rankingcontent > li > span {
  @media only screen and (max-width: 767px) {
    font-size: 14px;
    display: flex;
    align-items: center;
  }

  @media only screen and (min-width: 768px) {
    font-size: 16px;
  }

  text-align: left;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rankingcontent li .num {
  position: relative;

  width: 30px;
  height: 26px;
  background-repeat: no-repeat;
  background-size: cover;
  color: #068358;
  background-image: url(../../public/pc/01-icon-04.png);

  margin-right: 10px;
}

.rankingcontent li {
  color: #333;
}

.rankingcontent li:nth-of-type(1) .num {
  color: #fff;
  background-size: cover;
  font-weight: bold;
  background-image: url(../../public/pc/01-icon-01.png);
}

.rankingcontent li:nth-of-type(1),
.rankingcontent li:nth-of-type(2),
.rankingcontent li:nth-of-type(3) {
  font-weight: bold;
  color: #333;
}

.rankingcontent li:nth-of-type(2) .num {
  color: #fff;

  background-size: cover;
  background-image: url(../../public/pc/01-icon-02.png);
}

.rankingcontent li:nth-of-type(3) .num {
  color: #fff;

  background-size: cover;
  background-image: url(../../public/pc/01-icon-03.png);
}

.num > span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-60%, -55%);
  font-size: 14px;
}

.sectioncontent .bodythree {
  width: 100%;
  display: flex;
  border-radius: 10px;
  flex-direction: column;
  background-color: #fff;
  padding: 20px 20px 32px;
  box-sizing: border-box;
  overflow: hidden;
}

.newstitle {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgb(228, 227, 227);
}

.recommend {
  display: flex;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    padding-top: 10px;
  }

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    padding-top: 36px;
  }
}

.recommend > li:nth-child(1) {
  @media only screen and (max-width: 767px) {
    width: 100%;
  }

  @media only screen and (min-width: 768px) {
    width: 32%;
  }
}

.recommend > li {
  @media only screen and (max-width: 767px) {
    width: 100%;
    margin: 10px 0;
  }

  @media only screen and (min-width: 768px) {
    width: 32%;
    margin: 10px;
  }

  display: flex;
  flex-direction: column;
  text-align: left;
  box-sizing: border-box;

  > .img {
    border-radius: 12px;
    position: relative;
    overflow: hidden;
    height: auto;
    display: flex;
    outline: none;
    border: none;
    height: 200px;

    .fengmian {
      width: 100%;
      height: 100%;
    }

    > .icon {
      position: absolute;
      left: 0;
      top: -1px;
      width: 15%;
    }
  }
}

.recommend > li > h2 {
  font-weight: 400;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;
}

.recommend > li > .recommendtext {
  color: #999;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.recommendtext > .browse {
  display: flex;
  justify-content: center;
  align-items: center;
}

.recommendtext .browseone {
  margin-left: 15px;
}

.bodyfour {
  margin-top: 25px;
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
  }

  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
}

.visit {
  @media only screen and (max-width: 767px) {
    width: 100%;
  }

  @media only screen and (min-width: 768px) {
    width: 49%;
  }

  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  box-sizing: border-box;
  border-radius: 10px;
}

#visitstatistics,
#studystatistics {
  width: 100%;
  height: 300px;
}

.footer {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  background-color: rgb(241, 241, 241);
}

.footer > .footlink {
  width: 80%;
  margin: auto;
  height: 200px;
  display: flex;
  padding: 15px;
  flex-direction: column;
}

.linkhead {
  display: flex;
  width: 100%;
  height: 50px;
  justify-content: space-between;
  border-bottom: 1px solid rgb(201, 199, 199);
}

.linkhead > .linkheadleft {
  display: flex;
  border-bottom: 4px solid #999;
  padding: 0 15px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 180px;
}

.linkheadleft > img {
  width: 26px;
  height: 26px;
  margin-right: 15px;
}

.linkheadleft > h2 {
  font-size: 22px;
}

.searchbox {
  width: 100%;
  background-color: #fff;
  height: 40px;
  margin: auto;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  display: flex;
  margin-bottom: 20px;

  @media only screen and (max-width: 767px) {
    display: flex;
  }

  @media only screen and (min-width: 768px) {
    display: none;
  }

  input {
    width: 100%;
    outline: none;
    background-color: transparent;
    border: none;
    box-sizing: border-box;
    padding: 0 20px;
  }

  i {
    position: absolute;
    font-size: 24px;
    right: 15px;
    top: 6px;
    color: #068358;
  }
}

.bodyfive {
  @media only screen and (max-width: 767px) {
    width: 90%;
    margin: auto;
    border-radius: 10px;
    background-color: #eceff5;
    padding-bottom: 10px;
  }

  @media only screen and (min-width: 768px) {
    width: 100%;
    background-color: #eceff5;
    padding-bottom: 10px;
  }

  .fivecontent {
    @media only screen and (max-width: 767px) {
      width: 100%;
      height: 100%;
      margin: auto;
      box-sizing: border-box;
      padding: 20px;
    }

    @media only screen and (min-width: 768px) {
      width: 1200px;
      height: 100%;
      margin: auto;
      box-sizing: border-box;
      padding: 20px;
    }

    .fivecontent_head {
      display: flex;
      width: 100%;
      font-weight: bold;

      border-bottom: 1px solid rgb(211, 211, 211);

      span {
        display: flex;
        align-items: center;

        img {
          margin-right: 10px;
        }

        font-size: 18px;
        width: 130px;
        padding: 5px;
        border-bottom: 3px solid #999;
      }
    }

    ul::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }

    ul {
      margin-top: 20px;

      box-sizing: border-box;

      @media only screen and (max-width: 767px) {
        overflow-x: scroll;
        display: -webkit-box;
      }

      @media only screen and (min-width: 768px) {
        justify-content: space-between;
        display: flex;
      }

      li {
        @media only screen and (max-width: 767px) {
          width: 200px;
          margin: 0 10px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: center;
        }

        @media only screen and (min-width: 768px) {
          width: 19.5%;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: center;
        }

        display: flex;
        align-items: center;

        img {
          width: 100%;
        }

        span {
          color: #999;
          white-space: nowrap;

          margin-top: 10px;

          @media only screen and (max-width: 767px) {
            font-size: 12px;
          }

          @media only screen and (min-width: 768px) {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>

<style>
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #848da8;
}

.el-select-dropdown__item {
  color: #fff;
}

.choseacademy .el-select .el-input .el-select__caret {
  position: absolute;
}

.searchcontent .el-input__inner {
  color: #a5a7bb !important;
  border-radius: 2px;
  background-color: #f5f7fd;
  margin-bottom: 0 !important;
  width: 100%;
}

.el-select-dropdown {
  background-color: #50545e !important;
  border: none;
  opacity: 0.9;
  color: #fff !important;
}

.popper__arrow {
  display: none !important;
}

.el-input__inner:focus {
  border-color: #6f7a9b;
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: #6f7a9b;
}

.el-select .el-input__inner:focus {
  border-color: #6f7a9b;
}

.el-select-dropdown__item.selected {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue